import { Button, Group, PasswordInput, Radio } from '@mantine/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeUser } from '../../Redux/reducers/userSlice';
import { SELECTED_CITY, TOKEN_KEY } from '../../Utils/Constants';
import { baseUrl } from '../../shared/baseUrl';
import { createNotification } from '../Common/CreateNotification';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NotLoggedIn from '../Common/NotLoggedIn';

const Deactivate = () => {
    const [value, setValue] = useState('2');
    const [error, setError] = useState(false)
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const accessToken = useRef()

    const checkToken = () => {
        const token = new URLSearchParams(document.location.search).get('access_token')
        if (token === null || token === '') {
            //check if user is logged in
            const user = JSON.parse(localStorage.getItem('thrift-client-token'))
            const userToken = user?.token
            if (userToken === null || userToken === '') {
                return null
            } else {
                return userToken
            }
        }

        return token
    }

    const token = checkToken()

    useEffect(() => {
        if (token === null || token === '') {
            window.location.href = "/"
        } else {
            accessToken.current = token
            const url = new URL(window.location);
            url.searchParams.set('access_token', '');
            window.history.pushState(null, '', url.toString());
        }
    }, [])

    if (token === null || token === '' || token === undefined) {
        return <>
            <Helmet>
                <title>{`User - Account - Thrift Store Nepal`}</title>
                <meta
                    name="description"
                    content="User - Thrift Store Nepal - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta
                    property="og:title"
                    content={`User - Account - Thrift Store Nepal`}
                />
                <meta
                    property="og:description"
                    content="User - Thrift Store Nepal - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
                />
                <meta name="og:image" content="/assets/images/og-2.png" />
            </Helmet>
            <NotLoggedIn />
        </>
    }

    const deactivate = async () => {
        setIsLoading(true)
        var formData = new FormData()

        formData.append('password', password)
        formData.append('request_type', value)

        const resp = await fetch(baseUrl + 'account-remove', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                'Authorization': 'Bearer ' + accessToken.current,
            },
            body: JSON.stringify({
                password,
                request_type: value
            })
        })
        const response = await resp.json()

        if (response.success) {
            createNotification('success', response.message[0]);
            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem(SELECTED_CITY);
            dispatch(changeUser(null));
            navigate('/')
        }
        else {
            createNotification('error', "There was some issue deactivating your account.");
        }

        setIsLoading(false)
    }


    return <div style={{ height: "80vh" }} className='d-flex flex-wrap w-100 justify-content-center align-items-center'>
        <div className='small shadow p-4' style={{ borderRadius: 10, maxWidth: "60vh", }}>
            <img alt="logo" style={{ objectFit: "contain", height: "8vh", width: "8vh", filter: "revert", tintColor: 'gray' }} src="/assets/images/logo.png" />
            <div className='mt-4'>
                <Radio.Group
                    value={value}
                    onChange={setValue}
                    name="thrift"
                    label="Please choose from the following:"
                    description="Choose how do you want to deactivate your account"
                    withAsterisk
                >
                    <Group mt="xs">
                        <Radio
                            disabled={isLoading}
                            value="2"
                            label={<div>
                                <p className='fw-bold text-warning mb-0'>Deactivate</p>
                                <p className='small mb-0'>By deactivating, all your data will be hidden from the other users but it will be secured with us. The next time you log in again, all your data will be restored and be visible to all the users and you can use the app normally. (Recommended)</p>
                            </div>}
                        />
                        <Radio
                            disabled={isLoading}
                            value="1"
                            label={<div>
                                <p className='fw-bold text-danger mb-0'>Delete</p>
                                <p className='small mb-0'>By deleting, all your data will be removed from our app permanently and other users will not be able to see it too. You won't be able to log in again and you will have to sign in again if you want to continue using our app. Your data will be lost and will not be restored upon next sign up. (Not recommended)</p>
                            </div>}
                        />
                    </Group>
                </Radio.Group>
                <div className='mt-3'>
                    <PasswordInput
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value)
                            if (e.target.value.length === 0) {
                                setError('Password required')
                            } else if (e.target.value.length >= 0) {
                                setError('')
                            }
                        }}
                        mt="xl"
                        description="Please enter your password to continue"
                        placeholder="Password"
                        error={error}
                        inputWrapperOrder={['label', 'description', 'input']}
                        type='password'
                        disabled={isLoading}
                        autoComplete='off'
                    />
                </div>
            </div>
            <div className='d-flex justify-content-end'>
                <Button
                    loading={isLoading}
                    disabled={isLoading}
                    onClick={() => {
                        if (password.length <= 0) {
                            setError('Password required')
                        } else {
                            deactivate()
                        }
                    }}
                    className='mt-3'
                    style={{ background: "#d1027e" }}
                >
                    Confirm
                </Button>
            </div>
        </div>
    </div>
}

export default Deactivate